module.exports = __webpack_public_path__ + "static/media/logo_edugry.1d252bd9.svg";